<div class="row ss-top-menu">
  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-6 col-xs-6 d-flex align-items-center">
    <span class="ss-text-light ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/']">Dashboard</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-light ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: lead_status}" *ngIf="(role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager' || role=='sales_manager'|| role=='area_sales_manager')">Lead</span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/designer/leads']" [queryParams]="{customer_status: lead_details.lead_status}" *ngIf="role=='designer' && lead_details">Lead </span>
    <span *ngIf="lead_details" class="capitalize" style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> {{lead_details.lead_status | replaceChar}}</span>
    <!-- <span style="vertical-align: -webkit-baseline-middle;" *ngIf="lead_details.user_reference"><i class="rightArrow fa fa-angle-right"></i> </span> -->
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark capitalize" style="vertical-align: -webkit-baseline-middle;" *ngIf="lead_details && lead_details.user_reference">{{lead_details.user_reference.name}}</span>&nbsp;
    <span *ngIf="!is_before_email_verify">
    <span *ngIf="!emailverified" title="Email not verified" class="verifymessage  d-flex align-items-center" routerLink="/lead/{{lead_id}}/basic-info" [queryParams]="{lead_status: lead_status}" style="color: #8D0528;">     
      <svg version="1.1" id="Icons" class=" content" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" xml:space="preserve" width="23px" height="23px" fill="#000000">
            <g id="SVGRepo_bgCarrier" stroke-width="0"/>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>                
        <style type="text/css">
             .st4{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
             .st5{fill:red;}
             .st6{stroke: #ffffff ;}
             </style>
          <polyline class="st4" points="3,8 16,16 29,8 "/>
          <path class="st4" d="M17.1,25H7c-2.2,0-4-1.8-4-4V7c0-2.2,1.8-4,4-4h18c2.2,0,4,1.8,4,4v12.1"/>
          <circle class="st4 st5" cx="24" cy="24" r="7" />
          <line class="st4 st6" x1="22" y1="22" x2="26.1" y2="26.1"/>
          <line class="st4 st6" x1="22" y1="26.1" x2="26.1" y2="22"/>
      </svg> 
    </span>
    <span *ngIf="emailverified" class="d-flex align-items-center" style="color: #8D0528;" title="Email verified ">
        <svg version="1.1" id="Icons" class=" content" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" xml:space="preserve" width="20px" height="20px" fill="#000000">
      
          <g id="SVGRepo_bgCarrier" stroke-width="0"/>
          
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>                <style type="text/css">
          .st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
          .st1{fill:none;stroke:#8D0528;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
          .st2{fill:green;}
          .st3{stroke: #ffffff ;}
        </style>
        <path class="st0 " d="M17.1,25H7c-2.2,0-4-1.8-4-4V7c0-2.2,1.8-4,4-4h18c2.2,0,4,1.8,4,4v12.1"/>
        <polyline class="st0" points="3,8 16,16 29,8 "/>
        <circle class="st0 st2" cx="24" cy="24" r="7" fill=""/>
        <polyline class="st0 st3" points="27,22 23,26 21,24 "/>
        </svg>    
    </span> 
    </span>
  </div>
</div>

<div class="rk-ui-notification err" *ngIf="erroralert" style="z-index: 10000;">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="rk-ui-notification" *ngIf="successalert" style="z-index: 10000;">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>

<div class="row px-4">
  <app-shared-top-menu [lead_id]='lead_id' [lead_details]='lead_details' [lead_status]='lead_status' [files_tab]='"active"'></app-shared-top-menu>
  <div class="col-12 bg-white mb-3 mt-4 customFileContainer">
    <app-sms-call></app-sms-call>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-3 inc-side-panel pt-4 pb-5">
            <ul class="pl-0">
              <li class="mb-4">
                  <span class="fileExploreTxt">File Explorer</span>
              </li>
              <li class="cursor-pointer inc-link" (click)="displaySection('floorplan-section')" routerLink="." [queryParams]="{tab:'floorplan-section'}" [ngClass]="{'active': state == 'floorplan-section'}">
                <span>
                  <img class="mr-2 folderImageStyle" src="./assets/img/new_folder.svg">
                </span>
                <span class="fileSecondaryTxt"> Floor Plan / Layout</span>
              </li>
              <li class="cursor-pointer inc-link" (click)="displaySection('site-section')" routerLink="." [queryParams]="{tab:'site-section'}" [ngClass]="{'active': state == 'site-section'}">
                <span>
                  <img class="mr-2 folderImageStyle" src="./assets/img/new_folder.svg">
                </span>
                <span class="fileSecondaryTxt">Site Measurement</span>
              </li>
              <li class="cursor-pointer inc-link" (click)="displaySection('cad-section')" routerLink="." [queryParams]="{tab:'cad-section'}" [ngClass]="{'active': state == 'cad-section'}">
                <span>
                  <img class="mr-2 folderImageStyle" src="./assets/img/new_folder.svg">
                </span>
                <span class="fileSecondaryTxt">CAD Drawings</span>
              </li>
              <li class="cursor-pointer inc-link" (click)="displaySection('ppt-section')" routerLink="." [queryParams]="{tab:'ppt-section'}" [ngClass]="{'active': state == 'ppt-section'}">
                <span>
                  <img class="mr-2 folderImageStyle" src="./assets/img/new_folder.svg">
                </span>
                <span class="fileSecondaryTxt">PPT</span>
              </li>
              <li class="cursor-pointer inc-link" (click)="displaySection('pdf-file-section')" routerLink="." [queryParams]="{tab:'pdf-file-section'}" [ngClass]="{'active': state == 'pdf-file-section'}">
                <span>
                  <img class="mr-2 folderImageStyle" src="./assets/img/new_folder.svg">
                </span>
                <span class="fileSecondaryTxt">Files</span>
              </li>
              <li class="cursor-pointer inc-link" (click)="displaySection('warranty-document-section')" routerLink="." [queryParams]="{tab:'warranty-document-section'}" [ngClass]="{'active': state == 'warranty-document-section'}">
                <span>
                  <img class="mr-2 folderImageStyle" src="./assets/img/new_folder.svg">
                </span>
                <span class="fileSecondaryTxt">Warranty Document</span>
              </li>
              <li class="cursor-pointer inc-link" (click)="displaySection('elevation-section')" routerLink="." [queryParams]="{tab:'elevation-section'}" [ngClass]="{'active': state == 'elevation-section'}">
                <span>
                  <img class="mr-2 folderImageStyle" src="./assets/img/new_folder.svg">
                </span>
                <span class="fileSecondaryTxt">Elevations</span>
              </li>
              <li class="cursor-pointer inc-link" (click)="displaySection('reference-section')" routerLink="." [queryParams]="{tab:'reference-section'}" [ngClass]="{'active': state == 'reference-section'}">
                <span>
                  <img class="mr-2 folderImageStyle" src="./assets/img/new_folder.svg">
                </span>
                <span class="fileSecondaryTxt">Reference Files</span>
              </li>
               <li class="cursor-pointer inc-link" (click)="displaySection('threed-section')" routerLink="." [queryParams]="{tab:'threed-section'}" [ngClass]="{'active': state == 'threed-section'}">
                <span>
                  <img class="mr-2 folderImageStyle" src="./assets/img/new_folder.svg">
                </span>
                <span class="fileSecondaryTxt">3-D Files</span>
              </li>
              <li class="cursor-pointer inc-link" (click)="displaySection('line-marking-section')" routerLink="." [queryParams]="{tab:'line-marking-section'}" [ngClass]="{'active': state == 'line-marking-section'}">
                <span>
                  <img class="mr-2 folderImageStyle" src="./assets/img/new_folder.svg">
                </span>
                <span class="fileSecondaryTxt">Line Marking</span>
              </li>
              <li class="cursor-pointer inc-link" (click)="displaySection('file-inspiration-section')" routerLink="." [queryParams]="{tab:'file-inspiration-section'}" [ngClass]="{'active': state == 'file-inspiration-section'}">
                <span>
                  <img class="mr-2 folderImageStyle" src="./assets/img/new_folder.svg">
                </span>
                <span class="fileSecondaryTxt">Inspiration Board</span>
                </li>
              <li class="cursor-pointer inc-link" (click)="displaySection('mto-files-section')" routerLink="." [queryParams]="{tab:'mto-files-section'}" [ngClass]="{'active': state == 'mto-files-section'}">
                <span>
                  <img class="mr-2 folderImageStyle" src="./assets/img/new_folder.svg">
                </span>
                <span class="fileSecondaryTxt">MTO Files</span>
              </li>
              <li class="cursor-pointer inc-link" (click)="displaySection('catalogue')" routerLink="." [queryParams]="{tab:'catalogue'}" [ngClass]="{'active': state == 'catalogue'}">
                <span>
                  <img class="mr-2 folderImageStyle" src="./assets/img/new_folder.svg">
                </span>
                <span class="fileSecondaryTxt">Catalogue</span>
              </li>
            </ul>
          </div>
          <div class="col-md-9 pb-4">
            <app-files-floorplan [floorplans_list] = 'floorplans_list' (dataToParent)="receiveDataFromChild($event)" ></app-files-floorplan>
            <app-files-site-measurement (dataToParent)="receiveDataFromChild($event)" [siteRequestList] = 'siteRequestList' ></app-files-site-measurement>
            <app-files-cad [cadElevationList] = 'cadElevationList'></app-files-cad>
            <app-files-elevation [elevationFileList]= 'elevationFileList' (dataToParent)="receiveDataFromChild($event)"></app-files-elevation>
            <app-file-ppt [pptFileList] = 'pptFileList' (dataToParent)="receiveDataFromChild($event)"></app-file-ppt>
            <app-file-boq [boqFileList] = 'boqFileList' (dataToParent)="receiveDataFromChild($event)"x></app-file-boq>
            <app-file-pdf [pdfFileList] = 'pdfFileList'></app-file-pdf>
            <app-files-reference-image [referenceImageList]= 'referenceImageList' (dataToParent)="receiveDataFromChild($event)"></app-files-reference-image>
            <app-files-threed-image [threeDImageList]="threeDImageList" (dataToParent)="receiveDataFromChild($event)"></app-files-threed-image>
            <app-file-warranty [project_id] = 'project_id' ></app-file-warranty>
            <app-inspiration-board [inspirationList] ='inspirationList'></app-inspiration-board>
            <app-mto-files [mtofiles] = 'mtofiles' (dataToParent)="receiveDataFromChild($event)"></app-mto-files>
            <app-catalogue [catalogue] = 'catalogue'></app-catalogue>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-nested-loader *ngIf="LoaderTest" >

</app-nested-loader>


// WEBPACK FOOTER //
// ./src/app/platform/lead/files/files.component.html